import { TextLargeParagraph } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

type StatsCardErrorOrEmptyProps = {
  title?: string;
  children: ReactNode;
};

export const StatsCardErrorOrEmpty = ({
  title,
  children,
}: StatsCardErrorOrEmptyProps) => {
  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex items-center pl-6 h-ds-15 border-b border-b-ds-natural-150">
        <TextLargeParagraph
          label={title || ''}
          color="text-ds-natural-600"
        />
      </div>
      <div className="grow">{children}</div>
    </div>
  );
};
